/**
 * Utilidades para redirección tras login (returnUrl).
 * Normaliza deep links del CRM sin prefijo (/tasks/:id, etc.) a /crm/...
 */

/**
 * Normaliza returnUrl de deep links sin prefijo (/tasks/:id, /calls/:id, etc.) a /crm/...
 * para que tras el login el usuario llegue a la ruta correcta del CRM.
 */
export function normalizeCrmReturnUrl(returnUrl: string | null): string | null {
  if (!returnUrl || returnUrl.startsWith('/crm')) return returnUrl;
  const match = returnUrl.match(/^\/(tasks|calls|opportunities|contacts|leads)\/([a-f0-9-]+)(\/.*)?$/i);
  if (match) {
    const [, segment, id, rest = ''] = match;
    return `/crm/${segment}/${id}${rest || ''}`;
  }
  return returnUrl;
}
